/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/doModify';

type p3_bre_guid = string //  角色GUID

export interface request {
  p3_bre_guid: p3_bre_guid,
  p4_node_id: p4_node_id[]
}

type p4_node_id = {
  [prop: number]: number
}

export interface AxiosResponse extends AxiosResponse<responseData> { }

interface responseData extends backendResponse {
  response: any
}
